export const paths = {
  root: '/',
  transactions: '/transactions',
  transaction: (id) => `/transaction/${id}`,
  toExchange: '/to-exchange',
  sendUsd: '/send-usd',
  privacy: '/privacy',
  terms: '/terms',
  maintenance: '/maintenance',
  admin: {
    root: '/admin/dashboard',
    login: '/admin/login',
    verifyToc: '/admin/verify-toc',
    forgetpassword: '/admin/forget-password',
    dashboard: '/admin/dashboard',
    users: '/admin/users',
    lpUsers: '/admin/lp-users',
    create: '/admin/create',
    transactions: '/admin/transactions',
    onchainTransactions: '/admin/onchain-transactions',
    fiatBalance: '/admin/fiat-balance',
    transaction: (id) => `/admin/transaction/${id}`,
    settings: '/admin/settings',
    userProfile: (phoneNumber) => `/admin/users/${phoneNumber}`,
  },
  lp: {
    root: '/lp/dashboard',
    login: '/lp/login',

    lpProfile: (id) => `/admin/lp-users/${id}`,
    forgetpassword: '/lp/forget-password',
    verifyToc: '/lp/verify-toc',
    dashboard: '/lp/dashboard',
  },
};
